<div class="content"><slot></slot></div>